import { dailyPicker } from "../utils.ts";

// From Bananagrams
const weights = [
  13, 3, 3, 6, 18, 3, 4, 3, 12, 2, 2, 5, 3, 8, 11, 3, 2, 9, 6, 9, 6, 3, 3, 2, 3,
  2,
];

const lookup: number[] = [];
for (let i = 0; i < weights.length; i++) {
  for (let k = 0; k < weights[i]; k++) {
    lookup.push(i);
  }
}

export function dailyLetters(day: Date, count: number): string[] {
  const pick = dailyPicker(day);
  return Array.from({ length: count }, () =>
    String.fromCharCode(97 + pick(lookup)),
  );
}

export function binarySearch(list: string[], word: string) {
  let low = 0;
  let high = list.length - 1;
  while (low <= high) {
    const mid = (low + high) >> 1;
    if (list[mid] === word) return true;
    if (list[mid] < word) {
      low = mid + 1;
    } else {
      high = mid - 1;
    }
  }
  return false;
}

const COLUMNS = 4;

export function navigate(slots: readonly unknown[], from: number, key: string) {
  let to: number;
  switch (key) {
    case "ArrowLeft":
      to = slots.findLastIndex((letter, i) => letter && i < from);
      break;
    case "ArrowRight":
      to = slots.findIndex((letter, i) => letter && i > from);
      break;
    case "ArrowUp":
      to = nearestInRow(slots, from, -COLUMNS);
      break;
    case "ArrowDown":
      to = nearestInRow(slots, from, COLUMNS);
      break;
    case "Home":
      to = slots.findIndex(Boolean);
      break;
    case "End":
      to = slots.findLastIndex(Boolean);
      break;
    default:
      return;
  }
  return to === -1 ? from : to;
}

function nearestInRow(slots: readonly unknown[], from: number, step: number) {
  const column = from % COLUMNS;
  for (
    let row = from - column + step;
    row >= 0 && row < slots.length;
    row += step
  ) {
    for (let d = 0; d < COLUMNS; d++) {
      for (const c of [column - d, column + d]) {
        if (c >= 0 && c < COLUMNS && slots[row + c]) return row + c;
      }
    }
  }
  return -1;
}
